<label class="input-label flex"
  >{{ label }}
  @if (isRequired) {
    <p class="text-err">*</p>
  }
</label>
<div class="custom-select">
  <select class="shared-input" [formControl]="control">
    <option value="" [disabled]="false" selected>Select...</option>
    @for (o of options; track o; let idx = $index) {
      <option [value]="values.at(idx) ?? o">{{ o }}</option>
    }
  </select>
</div>

@if (control.invalid && control.touched) {
  <p class="input-err">Required field.</p>
}
